import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const Dash: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 16 16"><path d="M6 8H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Dash;